import angular from "angular";
import { UserGlobalRolesEditorComponent } from "./user-global-roles-editor.component";
import { UserPermissionEditorModalComponent } from "./user-permission-editor-modal.component";
import { UserSecurityEditorComponent } from "./user-security-editor.component";
import { UserSecurityPermissionsEditorComponent } from "./user-security-permissions-editor.component";
import { UserSecurityRolesEditorComponent } from "./user-security-roles-editor.component";

export const UserSecurityEditorModule = angular
    .module("apex.mainApp.roster.edit.security", [])
    .component("apexUserGlobalRolesEditor", UserGlobalRolesEditorComponent)
    .component("apexUserPermissionEditorModal", UserPermissionEditorModalComponent)
    .component("apexUserSecurityEditor", UserSecurityEditorComponent)
    .component("apexUserSecurityPermissionsEditor", UserSecurityPermissionsEditorComponent)
    .component("apexUserSecurityRolesEditor", UserSecurityRolesEditorComponent)
    .name;
